
<style scoped lang="scss">
li {
  list-style: none;
}
.nav_box {
  // position: fixed;
  left: 0;
  height: 100%;
  overflow-y: auto;
  background: #fff;
  width: 210px;

  ul {
    width: 100%;
    padding: 0;
    margin: 0;
  }
  li.title {
    background: #f9f9f9;
    color: #999999;
    padding-left: 50px;
  }
  li {
    box-sizing: border-box;
    padding-left: 60px;
    height: 50px;
    line-height: 50px;
    text-align: left;
    color: #666666;
    cursor: pointer;
    font-size: 14px;
  }
  li.c:hover {
    background: #f0f6ff;
  }
  li.li_active {
    background: #f0f6ff;
    border-right: 3px solid #3399ff;
    color:#409eff;
  }
}
.nav_box::-webkit-scrollbar{
      width:0;
}
</style>
<template>
  <div class="nav_box">
    <ul>
      <li
        v-for="(item, index) in nav"
        :key="index"
        :class="item.type == 'title'?'title' : item.active ? 'c li_active' : 'c'"
        @click="handleClick(item)"
      >
        {{ item.chName }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav: [
      ],
    };
  },
  methods: {
    handleClick(item) {
      let tempIndex = this.nav.indexOf(item);
      this.nav = this.nav.map((item) => {
        item.active = false;
        return item;
      });
      this.nav[tempIndex].active = true;
      this.$router.push(item.url);
    },
  },
  mounted(){
    
    // let menus =  this.$store.state.user.menus.data;
    let menus =  JSON.parse(localStorage.getItem('USER_MENU_LIST'))
    console.log(menus);
    let menu = menus.filter((item) => {
      if (item.enName == "ywzx") return item;
    })[0];
    this.nav = menu.children;
    if (this.nav == null) {
      this.nav = []
    }
    let tempPath = this.$route.path;
    let tempObj = this.nav.filter((item) => {
      if (item.url == tempPath) return item;
    })[0];
    let tempIndex = this.nav.indexOf(tempObj);
    this.nav = this.nav.map((item) => {
      item.active = false;
      return item;
    });
    if (this.nav[tempIndex] != null) {
      this.nav[tempIndex].active = true;
    }
    // 二级菜单
    let childrens = []
    this.nav.forEach(parent => {
      if (parent.children != null && parent.children.length > 0) {
        childrens = childrens.concat(parent.children)
      }
    })
    this.nav = this.nav.concat(childrens)
    this.nav.sort((item1, item2) => {
      return item1.id - item2.id
    })

  }
};
</script>

